import { Code } from '../data/text-or-code.js'
import { Parameter } from '../script/parameter.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'

export const ServiceProviderMethodParameterTypes = {
	path: 'Path parameter',
	query: 'Query parameter',
	header: 'Header parameter',
	cookie: 'Cookie parameter',
	body: 'Request body',
}
export type ServiceProviderMethodParameterType =
	keyof typeof ServiceProviderMethodParameterTypes
export const ServiceProviderMethodHttpMethods = [
	'GET',
	'POST',
	'PUT',
	'DELETE',
	'PATCH',
]
export type ServiceProviderMethodHttpMethod =
	(typeof ServiceProviderMethodHttpMethods)[number]
export const ServiceProviderMethodWrappers = {
	raw: 'Raw content (no wrapper)',
	dataAndError: 'JSON object with data and error properties',
	response: 'Manually respond using Response object (advanced)',
}
export type ServiceProviderMethodWrapper =
	keyof typeof ServiceProviderMethodWrappers

@jsonClass('ServiceProviderMethodParameter')
export class ServiceProviderMethodParameter extends Parameter {
	@jsonProperty(String) parameterType: ServiceProviderMethodParameterType =
		'query'
}

@jsonClass('ServiceProviderMethod')
export class ServiceProviderMethod {
	@jsonProperty(String) name: string
	@jsonProperty(String) path: string
	@jsonProperty(String) httpMethod: ServiceProviderMethodHttpMethod = 'GET'
	@jsonArrayProperty(String) availableInVersions: string[] = []
	@jsonProperty(String) tsReturnType: string
	@jsonArrayProperty(ServiceProviderMethodParameter)
	parameters: ServiceProviderMethodParameter[] = []
	@jsonProperty(Code) tsCode = new Code()
	@jsonProperty() wrapper: ServiceProviderMethodWrapper = 'dataAndError'
	@jsonProperty() returnMimeType: string

	constructor(init?: Partial<ServiceProviderMethod>) {
		assignCommonProperties(this, init)
	}
	getPathRegexAsString() {
		return `/^${this.path
			.replace(/\{([^}]+)\}(.)?/g, (_, paramName, charAfter) => {
				const param = this.parameters.find((p) => p.name == paramName)
				if (!param)
					throw new Error(
						`Parameter "${paramName}" not found in method "${this.name}"`,
					)

				if (param.type == 'number')
					return `(?<${paramName}>\\d+)${charAfter ?? ''}`
				if (charAfter) return `(?<${paramName}>[^${charAfter}]+)${charAfter}`
				return `(?<${paramName}>[^/]+)`
			})
			.replaceAll('/', '\\/')}$/`
	}

	canHaveTsReturnType() {
		return this.wrapper != 'response'
	}

	getTsReturnType() {
		return this.canHaveTsReturnType() ? this.tsReturnType : 'void'
	}
}
